module.exports = __webpack_public_path__ + "static/media/file11.69632bec.jpg";